// Zentrale Hilfen für die Zähler in der Navigation (Mail-Anfragen, Kundenportal, E-Mail-Ton).
// Regel: Eine Abfrage, die nicht klappt (PC aus dem Ruhezustand, Server-Neustart), zählt NIE als 0,
// sondern behält den letzten bekannten Wert und löst in dieser Runde keine „neu“-Meldung aus.
// Der erste erfolgreiche Lauf nach dem Seitenstart setzt nur den Ausgangswert.

// Fragt `pfad` ab. Liefert { data, ok }. Bei Fehler: data = letzter bekannter Wert (oder null), ok = false.
export async function zaehlerAbfrage(api, pfad, merker) {
  try {
    const r = await api.get(pfad);
    merker[pfad] = r.data;
    return { data: r.data, ok: true };
  } catch {
    return { data: merker[pfad] ?? null, ok: false };
  }
}

// Entscheidet, ob eine „neu“-Meldung nötig ist.
// alt: letzter Merker (null = noch nie gesetzt), neu: aktueller Wert, ok: alle Abfragen dieser Runde geklappt.
// Liefert { melden, merker, anzahl }.
export function pruefeAnstieg(alt, neu, ok) {
  if (!ok) return { melden: false, merker: alt, anzahl: 0 };
  if (alt === null || alt === undefined) return { melden: false, merker: neu, anzahl: 0 };
  return { melden: neu > alt, merker: neu, anzahl: Math.max(0, neu - alt) };
}
